// extracted by mini-css-extract-plugin
export default {"main":"Layout_main__SYdan","main_standard":"Layout_main_standard__6YitA","main_gray":"Layout_main_gray__eRWf+"};